import React from 'react';
import './CasinoCard.css';

function StarRating({ rating }) {
  const stars = 5;
  const filled = Math.round((rating / 10) * stars);
  return (
    <div className="star-rating" aria-label={`Vurdering: ${rating} ud af 10`}>
      {Array.from({ length: stars }, (_, i) => (
        <span key={i} className={`star ${i < filled ? 'filled' : 'empty'}`} aria-hidden="true">★</span>
      ))}
      <span className="rating-num">{rating.toFixed(1)}</span>
    </div>
  );
}

export default function CasinoCard({ casino, variant = 'standard' }) {
  if (variant === 'featured') {
    return (
      <article className="casino-card casino-card--featured">
        <div className="casino-card__featured-badge">Redaktionelt Valg</div>
        <div className="casino-card__featured-inner">
          <div className="casino-card__featured-logo">
            <img
              src={casino.logo}
              alt={`${casino.name} logo`}
              onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
            />
            <div className="logo-fallback" style={{ display: 'none' }}>{casino.name.slice(0, 2).toUpperCase()}</div>
          </div>
          <div className="casino-card__featured-content">
            <h3 className="casino-card__name">{casino.name}</h3>
            <p className="casino-card__highlight">{casino.highlight}</p>
            <StarRating rating={casino.rating} />
            <p className="casino-card__desc">{casino.description}</p>
            <div className="casino-card__tags">
              {casino.tags.map((tag, i) => (
                <span key={i} className={`badge ${i % 2 === 0 ? 'badge-blue' : 'badge-sand'}`}>{tag}</span>
              ))}
            </div>
            <div className="casino-card__actions">
              <a
                href={casino.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="btn btn-primary"
              >
                Besøg {casino.name}
              </a>
              <span className="casino-card__disclaimer">18+ | Spil ansvarligt</span>
            </div>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="casino-card casino-card--standard">
      <div className="casino-card__logo-wrap">
        <img
          src={casino.logo}
          alt={`${casino.name} logo`}
          className="casino-card__logo"
          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
        />
        <div className="logo-fallback" style={{ display: 'none' }}>{casino.name.slice(0, 2).toUpperCase()}</div>
        <div className="casino-card__rating-badge">{casino.rating.toFixed(1)}</div>
      </div>

      <div className="casino-card__body">
        <h3 className="casino-card__name">{casino.name}</h3>
        <p className="casino-card__desc">{casino.description}</p>
        <div className="casino-card__tags">
          {casino.tags.slice(0, 3).map((tag, i) => (
            <span key={i} className="badge badge-blue">{tag}</span>
          ))}
        </div>
      </div>

      <div className="casino-card__footer">
        <a
          href={casino.url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="btn btn-primary btn-sm casino-card__cta"
        >
          Besøg casino
        </a>
        <span className="casino-card__age">18+</span>
      </div>
    </article>
  );
}
